<template>
  <div id="sub_footer">
    <div>
      <!-- Nothing -->
    </div>

    <div>
      Une solution développée par
      <a href="http://iltr.fr" target="_blank">
        <img
          id="logo_iltr"
          src="../../assets/img/logo-iltr.png"
          class="d-inline-block align-top"
          alt="Logo ILTR"
        />
      </a>
    </div>

    <div>
      Version {{ version }}
    </div>
  </div>
</template>

<script>
export default {
  name: 'app-footer-brand',
  computed: {
    version() {
      return process.env.PORTAL_VERSION;
    },
  },
};
</script>

<style scoped>
  #sub_footer {
    display: flex;
    justify-content: space-between;
    align-items: center;
    box-shadow: 0 0 20px 0 rgba(0, 0, 0, 0.3);
    padding: 1rem 0;
    height: 3rem;
    background-color: #222222;
  }

  #sub_footer div {
    flex: 1;
    padding: 0 1rem;
    text-align: center;
  }

  #sub_footer div:first-child, #sub_footer div:last-child {
    font-size: 0.8rem;
  }

  #sub_footer div:first-child {
    text-align: left;
  }

  #sub_footer div:last-child {
    text-align: right;
  }

  #logo_iltr {
    margin-left: 0.5rem;
    transform: translateY(0.1rem);
    height: 1rem;
  }
</style>
